module.exports = __webpack_public_path__ + "roboto-v15-latin-regular.16e1d930cf13fb7a9563.woff";


//////////////////
// WEBPACK FOOTER
// /Users/mac/PlayGround/~/primeng/resources/themes/omega/fonts/roboto-v15-latin-regular.woff
// module id = ../../../../primeng/resources/themes/omega/fonts/roboto-v15-latin-regular.woff
// module chunks = 1